var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "training-filter-tool" }, [
    _c("h1", { staticClass: "title" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" psychology ")]),
      _vm._v("\n        " + _vm._s(_vm.$t("chatbotv2.training")) + "\n    "),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "search" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
      _vm._v(" "),
      _c("input", {
        staticClass: "search-input",
        attrs: {
          type: "text",
          placeholder: _vm.$t("chatbotv2.searchUserQuery"),
          maxlength: "256",
        },
        domProps: { value: _vm.cloneFilters.query },
        on: { change: _vm.handleQueryChange },
      }),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "tabs" }, [
      _c(
        "div",
        {
          staticClass: "tab",
          class: { active: !_vm.cloneFilters.ignored },
          on: {
            click: function () {
              return _vm.changeIgnoreFilterStatus(false)
            },
          },
        },
        [
          _c("span", { staticClass: "material-icons" }, [
            _vm._v(" record_voice_over "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("chatbotv2.unmatchedPhrases")) +
                "\n                "
            ),
            _c("div", { staticClass: "count" }, [_vm._v(_vm._s(_vm.rowCount))]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tab",
          class: { active: _vm.cloneFilters.ignored },
          on: {
            click: function () {
              return _vm.changeIgnoreFilterStatus(true)
            },
          },
        },
        [
          _c("span", { staticClass: "material-icons" }, [
            _vm._v(" visibility_off "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("chatbotv2.ignored")) +
                "\n                "
            ),
            _c("div", { staticClass: "count" }, [_vm._v(_vm._s(_vm.rowCount))]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "stories" },
      [
        _c("h6", [_vm._v(_vm._s(_vm.$t("chatbotv2.Scenario")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "select-story",
            attrs: {
              value: _vm.cloneFilters.storyId,
              placeholder: _vm.$t("chatbotv2.selectAStory"),
              "filter-option": false,
            },
            on: { select: _vm.handleSelectStory },
          },
          _vm._l(_vm.stories, function (story) {
            return _c(
              "a-select-option",
              {
                key: story._id,
                attrs: { value: story._id },
                on: {
                  click: function () {
                    return _vm.storySelectOptionClick(story._id)
                  },
                },
              },
              [
                _c("span", { staticClass: "blockTypeText" }, [
                  _vm._v(_vm._s(story.title)),
                ]),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "period" },
      [
        _c("h6", [_vm._v(_vm._s(_vm.$t("chatbotv2.timePeriod")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "select-story",
            attrs: {
              value: _vm.cloneFilters.period,
              placeholder: _vm.$t("chatbotv2.wholeTimeSpan"),
              "filter-option": false,
            },
            on: { select: _vm.handleSelectPeriod },
          },
          _vm._l(_vm.periods, function (period) {
            return _c(
              "a-select-option",
              {
                key: period.value,
                attrs: { value: period.value },
                on: {
                  click: function () {
                    return _vm.periodSelectOptionClick(period.value)
                  },
                },
              },
              [
                _c("span", { staticClass: "blockTypeText" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.time." + period.value))),
                ]),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }